module.exports = __webpack_public_path__ + "img/loadingVideo.8ea16030.gif";